/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { type ReactNode } from 'react';

import { jsx } from '@compiled/react';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	rows: {
		borderBlockStartColor: token('color.border', '#091E4224'),
		borderBlockStartStyle: 'solid',
		borderBlockStartWidth: token('border.width', '1px'),
		paddingBlockStart: token('space.100', '8px'),
	},
});

export interface DetailsSectionProps {
	children: ReactNode;
	title: string;
}

export const DetailsSection = ({ title, children }: DetailsSectionProps): JSX.Element => {
	return (
		<Stack space="space.050" role="region">
			<Heading size="small">
				<Text color="color.text.subtle" size="large" weight="medium">
					{title}
				</Text>
			</Heading>
			<Box xcss={styles.rows}>
				<Stack space="space.050">{children}</Stack>
			</Box>
		</Stack>
	);
};
